import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  style: {"enable-background":"new 0 0 16 16"},
  "xml:space": "preserve",
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "currentColor",
  class: "qi-1010"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "M8.389 6.411a.674.674 0 0 0-.264 1.319c.113.022.755.144 1.512.144.531 0 1.118-.06 1.62-.255 1.61-.63 2.663.011 2.7.034a.673.673 0 0 0 .741-1.121c-.067-.045-1.644-1.059-3.93-.166-.722.281-1.962.128-2.379.045zm6.309 2.903c-.067-.044-1.644-1.06-3.93-.166-.723.281-1.962.127-2.38.045a.673.673 0 0 0-.263 1.318c.113.023.755.144 1.511.144.531 0 1.118-.06 1.62-.255 1.61-.63 2.663.011 2.7.034a.671.671 0 0 0 .742-1.12z" }, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", { d: "M13.736 11.764a.699.699 0 0 0-.273.951.23.23 0 0 1-.004.234c-.033.056-.077.084-.132.084H2.673c-.055 0-.099-.028-.132-.084a.23.23 0 0 1-.005-.231l5.329-9.562c.066-.119.203-.12.27 0l.514.931a.7.7 0 1 0 1.226-.676l-.514-.93c-.281-.51-.79-.815-1.361-.815s-1.08.305-1.359.812l-5.328 9.561a1.642 1.642 0 0 0 .022 1.623c.286.484.786.773 1.338.773h10.654c.552 0 1.052-.289 1.338-.773a1.64 1.64 0 0 0 .022-1.623.7.7 0 0 0-.951-.275z" }, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_4))
}
export default { render: render }